/**
 * OVERRIDE EventDetails.jsx
 */

import EventDetails from '../../../../components/View/EventDetails';

export default EventDetails;